import moment from 'moment';

export function formatFullDate(date) {
  return moment(date).format('MMMM DD, YYYY');
}

export function formatDateTime(dateTime) {
  return moment(dateTime).format('MMM DD, YYYY, hh:mm A');
}

export function formatDateSimple(date) {
  return moment(date).format('MM/DD/YY');
}

export function formatTimeAgo(dateTime) {
  return moment(dateTime).fromNow();
}

// "Jun 12" same year, "Jun 12, 2025" otherwise.
export function formatShortDate(date) {
  if (!date) return '';
  const m = moment(date);
  return m.year() === moment().year() ? m.format('MMM D') : m.format('MMM D, YYYY');
}

// "Jun 12, 12:34 PM" same year, "Jun 12, 2025" otherwise (older dates drop time).
export function formatShortDateTime(date) {
  if (!date) return '';
  const m = moment(date);
  return m.year() === moment().year() ? m.format('MMM D, h:mm A') : m.format('MMM D, YYYY');
}

export function titleize(value) {
  if (!value) return '';
  return value.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
}

export function truncate(str, length = 50) {
  if (!str) return '';
  return str.length > length ? str.substring(0, length) + '...' : str;
}
